
import { $convertUTCDateToLocalDate,$rdoLang,$checkPerm,$removeLocalStorage } from '@shining3d/common-module/index';
import _get from 'lodash/get';
import info from './api';
import store from '@/store';
import { VueCookieNext } from '@shining3d/vue-cookie-next';
import { useLang } from '@shining3d/common-module/lang.js';
import router from '@/router';
const cc = VueCookieNext.getCookie( 'cc' ) || 'CN';
const { $t } = useLang( '@shining3d/info-component.infoComponent' );

// 获取个人信息
async function $getInfo() {
	const res = await info.getInfo();
	if ( res.status === 'success' ) {
		// 更新创建时间转换
		res.result.lastOn = $convertUTCDateToLocalDate( res.result.lastOn );
		res.result.createOn = $convertUTCDateToLocalDate( res.result.createOn );
		// 上次登录地址拼接
		const country = _get( res.result, 'lastRegion.country', '' );
		const city = _get( res.result, 'lastRegion.city', '' );
		const area = _get( res.result, 'lastRegion.area', '' );
		res.result.region = ( country === 'xx' ? ' ' : country ) + ' ' + ( area === 'xx' ? ' ' : area ) + ' ' + ( city === 'xx' ? ' ' : city );
		// 更新个人信息存储
		store.commit( 'setUserInfo', { ...res.result } || {});
		return { ...res.result };
	} else {
		// 更新个人信息存储
		store.commit( 'setUserInfo', {});
		return {};
	}
}

// 获取当前账号归属机构列表
const $getFactoryList = async ( type = { onlySelf: true, showMembers: true, lang: $rdoLang() }) => {
	if ( window.app.entryName ) { 
		const originMap = new Map([['doctordesk', 'doctorDesk'], ['dental', 'dentalCloud']]);
	  type.origin = originMap.get(window.app.entryName) || window.app.entryName;
	}
	const res = await info.getFactoryList( type );
	if ( res.status === 'success' && Array.isArray( res.result )) {
		// 处理创建更新时间
		res.result = res.result.map(( val ) => ({
			...val,
			memberCreateOn: $convertUTCDateToLocalDate( val.memberCreateOn ),
			memberChangeOn: $convertUTCDateToLocalDate( val.memberChangeOn )
		}));
		// 机构存在 && 存在已加入机构 && 默认机构全部为n && 非超管
		if ( res.result.length > 0 &&
			res.result.some(( val ) => val.memberStatus === 'active' ) &&
			res.result.every(( val ) => val.lastState === 'n' ) &&
			!$checkPerm( 'dental.admin_dental_order' )){
			res.result[ res.result.findIndex(( val ) => val.memberStatus === 'active' ) ].lastState = 'y';
		}
		// 存储机构列表存储
		store.commit( 'setFactoryObjs', [...res.result]);
		// 更新用户信息中的机构列表
		$setOrgList( res.result );
		return [...res.result];
	} else {
		// 不存在直接清空机构列表和机构选择
		store.commit( 'setFactoryObjs', []);
		store.commit( 'setFactorySelect', {});
		return [];
	}
};

// 获取当前账号权限列表
const $getPermList = async ( type = {}) => {
	const res = await info.getPermList( type );
	if ( res.status === 'success' && res.result && res.result.length > 0 ) {
		// 更新账号权限列表
		store.commit( 'setPermsList', [...res.result]);
		// 更新用户信息中的权限列表
		$setOrgList( '', res.result );
		return [...res.result];
	} else {
		// 更新账号权限列表
		store.commit( 'setPermsList', []);
		return [];
	}
};

// 更新local里的 userInfo 中机构列表和权限列表 用于登录页刷新
function $setOrgList( result, perms = '' ) {
	const orgList = [];
	if ( result && result.length ) {
		result.forEach(( v ) => {
			const obj = {};
			obj.isAdmin = v.isAdmin;
			obj.joinOn = v.joinOn;
			obj.memberExpire = v.memberExpired;
			obj.orgID = v.id;
			obj.orgName = v.name;
			obj.orgType = v.factoryType;
			obj.status = v.memberStatus;
			obj.tempState = v.tempState;
			orgList.push( obj );
		});
	}
	let userInfo = localStorage.getItem( 'userInfo' );
	try {
		userInfo = JSON.parse( userInfo );
		if ( userInfo ) {
			if ( orgList && orgList.length ) {
				userInfo.orgList = orgList;
			}
			if ( perms ) {
				userInfo.perms = perms;
			}
			localStorage.setItem( 'userInfo', JSON.stringify( userInfo ));
		}
	} catch ( error ) {
		console.log( 'localUserInfoErr', error );
	}
}
// 退出登录
function $logouts( redirectTo ) {
	VueCookieNext.removeCookie( 'token' );
	VueCookieNext.removeCookie( 'user_id' );
	VueCookieNext.removeCookie( 'uTitle' );
	$removeLocalStorage( 'cancelPromptFlag' );
	window.location.href = redirectTo || router.resolve({ name: 'oemDomainPage', params: { oemDomain: VueCookieNext.getCookie( 'oemURL' ) || 'index' } }).href;
}

// 获取国家码初始值
function $getPhoneArea( sd ) {
	if(store.state.countryList) {
    const PhoneArea = store.state.countryList.find(( val ) => val.id === ( sd || cc ));
	  return PhoneArea ? PhoneArea.phone : '86';
  } else{
    return '86';
  }
}
// msg报错处理
function $formErr( res, form, type = 'form' ) {
	if ( Object.keys( res ).length ) {
		for ( const key in form ) {
			form[ key ] = '';
		}
		console.log( form );
		nextTick(() => {
			Object.keys( res ).forEach(( val ) => {
				if ( type === 'form' ) {
					form[ val ] = res[ val ];
				} else {
					XlMessage({ type: 'error', message: res[ val ] });
				}
			});
		});
		console.log( form );
	} else {
		XlMessage({ type: 'error', message: res });
	}
}

// 枚举查询
async function $getSettingList({ type, lang }) {
	const res = await info.getSettingList( type );
	if ( res.status === 'success' && res.result && res.result.length > 0 ) {
		return res.result.map(( v ) => {
			const obj = {};
			obj.value = v.keyName;
			try {
				obj.label = JSON.parse( v.other )[ lang ];
			} catch ( error ) {
				obj.label = '';
			}
			return obj;
		});
	} else {
		return [];
	}
}
export {
  $getInfo,
  $getFactoryList,
  $logouts,
  $setOrgList,
  $getSettingList,
  $getPhoneArea,
  $getPermList,
	$formErr
}